const IPV4_OCTET = '(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])'
const IPV4_PATTERN = new RegExp(`^${IPV4_OCTET}(?:\\.${IPV4_OCTET}){3}$`)
const CIDR_PATTERN = new RegExp(`^${IPV4_OCTET}(?:\\.${IPV4_OCTET}){3}/(?:[0-9]|[12][0-9]|3[0-2])$`)
const HOSTNAME_LABEL_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i

export type AnalyticsSuppressionRuleKind = 'hostname' | 'ip' | 'ip_range'

const isHostname = (value: string): boolean => {
  if (value.length < 1 || value.length > 253 || !/[a-z]/i.test(value)) {
    return false
  }

  return value.split('.').every((label) => HOSTNAME_LABEL_PATTERN.test(label))
}

export const normalizeAnalyticsSuppressionRule = (value: string): string => {
  const normalized = value.trim()

  if (/[a-z]/i.test(normalized) && normalized.endsWith('.')) {
    return normalized.slice(0, -1).toLowerCase()
  }

  return isHostname(normalized) ? normalized.toLowerCase() : normalized
}

/** What a saved rule matches; null when the rule is not a hostname, IPv4 address or IPv4 CIDR. */
export const analyticsSuppressionRuleKind = (value: string): AnalyticsSuppressionRuleKind | null => {
  const normalized = normalizeAnalyticsSuppressionRule(value)

  if (IPV4_PATTERN.test(normalized)) {
    return 'ip'
  }
  if (CIDR_PATTERN.test(normalized)) {
    return 'ip_range'
  }
  return isHostname(normalized) ? 'hostname' : null
}

export const validateAnalyticsSuppressionRule = (value: string): string | null => {
  if (!normalizeAnalyticsSuppressionRule(value)) {
    return 'Enter a hostname or IP address first.'
  }

  return analyticsSuppressionRuleKind(value) ? null : "That isn't a hostname or IP address."
}
